import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import { isValidGSTIN, isValidPincode, isValidPhone } from '../../common/validators';
// import CitySelector from '../CitySelector';
import { toast } from 'react-toastify';
import Select from 'react-select';



const gstRegistrationOptions = [
    { value: 'registered', label: 'GST Registered' },
    { value: 'URD', label: 'URD (Unregistered Dealer)' },
];

function BrokerEditModal({ show, onHide, broker, onBrokerUpdated }) {
    const [form, setForm] = useState({
        business_name: '',
        alias: '',
        gst_registration: '',
        gstin: '',
        business_email: '',
        owner_name: '',
        owner_contact_no: '',
        address: '',
        town: '',
        city: '',
        state: '',
        pin_code: '',
        country: 'India',
        credit_period_allowed: '',
        pan_no: '',
        tan_no: ''
    });

    const [formSubmitted, setFormSubmitted] = useState(false);

    // Populate form from vendor prop
    useEffect(() => {
        if (broker) {
            setForm({
                business_name: broker.business_name || '',
                alias: broker.alias || '',
                gst_registration: broker.gst_registration || '',
                gstin: broker.gstin || '',
                business_email: broker.business_email || '',
                owner_name: broker.owner_name || '',
                owner_contact_no: broker.owner_contact_no || '',
                address: broker.address || '',
                town: broker.town || '',
                city: broker.city || '',
                state: broker.state || '',
                pin_code: broker.pin_code || '',
                country: 'India',
                credit_period_allowed: broker.credit_period_allowed || '',
                pan_no: broker.pan_no || '',
                tan_no: broker.tan_no || ''
            });
        }
    }, [broker]);

    const handleChange = e => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected, action) => {
        setForm(prev => ({ ...prev, [action.name]: selected?.value }));
    };

    const handleOwnerChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async e => {
        console.log("davdvds");
        e.preventDefault();
        setFormSubmitted(true);

        if (!form.town || !form.pin_code || !form.state || !form.city || !form.address || !form.business_name || !form.owner_name || !isValidPhone(form.owner_contact_no)) {
            return; // Prevent invalid submission
        }

        try {
            const response = await axios.put(`${config.API_BASE_URL}/brokers/${broker._id}`, form);

            if (response.data.success) {
                toast.success(response.data.message || 'Broker updated successfully!');
            }
            onBrokerUpdated();
            onHide();
        } catch (err) {
            console.error('Update broker failed:', err);
            const errorMessage = err.response?.data?.message || 'Failed to update broker!';
            toast.error(errorMessage);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Broker Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {/* Business & Industry Info */}
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Business Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="business_name"
                                    value={form.business_name}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.business_name}
                                />
                                <Form.Control.Feedback type="invalid">Business name is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Alias</Form.Label>
                                <Form.Control name="alias" value={form.alias} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2 fs-9">
                                <Form.Label>GST Registration Type</Form.Label>
                                <Select
                                    name="gst_registration"
                                    value={gstRegistrationOptions.find(opt => opt.value === form.gst_registration)}
                                    onChange={handleSelectChange}
                                    options={gstRegistrationOptions}
                                    placeholder="-- Select GST Type --"
                                />
                            </Form.Group>
                        </Col>

                        {form.gst_registration === 'registered' && (
                            <Col md={6} xl={4}>
                                <Form.Group className="mb-2">
                                    <Form.Label>GSTIN</Form.Label>
                                    <Form.Control
                                        name="gstin"
                                        value={form.gstin}
                                        onChange={handleChange}
                                        isInvalid={form.gstin && !isValidGSTIN(form.gstin)}
                                    />
                                    <Form.Control.Feedback type="invalid">Invalid GSTIN format.</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        )}

                        <hr className="my-3" />

                        {/* Owner & Contact */}
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Owner Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="owner_name"
                                    value={form.owner_name}
                                    onChange={(e) => handleOwnerChange('owner_name', e.target.value)}
                                    isInvalid={formSubmitted && !form.owner_name}
                                />
                                <Form.Control.Feedback type="invalid">Owner name is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Owner Contact Number <span className="text-danger">*</span></Form.Label>
                                <PhoneInput
                                    country="in"
                                    value={form.owner_contact_no}
                                    onChange={(value) => handleOwnerChange('owner_contact_no', `+${value}`)}
                                    inputProps={{ name: 'owner_contact_no' }}
                                    inputClass={
                                        formSubmitted && (!form.owner_contact_no || !isValidPhone(form.owner_contact_no))
                                            ? 'is-invalid' : ''
                                    }
                                />
                                {formSubmitted && !form.owner_contact_no && (
                                    <div className="invalid-feedback d-block">Owner Contact Number is required.</div>
                                )}
                                {form.owner_contact_no && !isValidPhone(form.owner_contact_no) && (
                                    <div className="invalid-feedback d-block">Invalid phone number format.</div>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Business Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="business_email"
                                    value={form.business_email}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <hr className="my-3" />

                        {/* Address */}
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label>Full Address <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="address"
                                    value={form.address}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.address}
                                />
                                <Form.Control.Feedback type="invalid">Address is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Town <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="town"
                                    value={form.town}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.town}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="city"
                                    value={form.city}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.city}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>State <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="state"
                                    value={form.state}
                                    isInvalid={formSubmitted && !form.state}
                                />
                                <Form.Control.Feedback type="invalid">State is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Pincode <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="pin_code"
                                    value={form.pin_code}
                                    isInvalid={formSubmitted && (!form.pin_code || !isValidPincode(form.pin_code))}
                                />
                                <Form.Control.Feedback type="invalid">Pincode must be exactly 6 digits.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <hr className="my-3" />

                        {/* Extra Info */}
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Credit Period Allowed</Form.Label>
                                <Form.Control
                                    name="credit_period_allowed"
                                    value={form.credit_period_allowed}
                                    onChange={handleChange}
                                    placeholder="e.g. 30 days"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>PAN No.</Form.Label>
                                <Form.Control name="pan_no" value={form.pan_no} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>TAN No.</Form.Label>
                                <Form.Control name="tan_no" value={form.tan_no} onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" variant="primary">Update Broker</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default BrokerEditModal;
